import { CreateOrEditReleasePage } from "./CreateOrEditReleasePage";
export function CreateReleasePage() {
    return <CreateOrEditReleasePage />;
}
